/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayoutDistribution } from './PayoutDistribution';
import {
    PayoutDistributionFromJSON,
    PayoutDistributionFromJSONTyped,
    PayoutDistributionToJSON,
    PayoutDistributionToJSONTyped,
} from './PayoutDistribution';
import type { PayoutTier } from './PayoutTier';
import {
    PayoutTierFromJSON,
    PayoutTierFromJSONTyped,
    PayoutTierToJSON,
    PayoutTierToJSONTyped,
} from './PayoutTier';

/**
 * 
 * @export
 * @interface PayoutTableResponse
 */
export interface PayoutTableResponse {
    /**
     * 
     * @type {string}
     * @memberof PayoutTableResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutTableResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutTableResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PayoutTableResponse
     */
    minTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof PayoutTableResponse
     */
    maxTeams?: number;
    /**
     * 
     * @type {Array<PayoutDistribution>}
     * @memberof PayoutTableResponse
     */
    distribution: Array<PayoutDistribution>;
    /**
     * 
     * @type {Array<PayoutTier>}
     * @memberof PayoutTableResponse
     */
    tiers: Array<PayoutTier>;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutTableResponse
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutTableResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayoutTableResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {number}
     * @memberof PayoutTableResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PayoutTableResponse
     */
    updatedAt?: number;
}

/**
 * Check if a given object implements the PayoutTableResponse interface.
 */
export function instanceOfPayoutTableResponse(value: object): value is PayoutTableResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('distribution' in value) || value['distribution'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function PayoutTableResponseFromJSON(json: any): PayoutTableResponse {
    return PayoutTableResponseFromJSONTyped(json, false);
}

export function PayoutTableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutTableResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'distribution': ((json['distribution'] as Array<any>).map(PayoutDistributionFromJSON)),
        'tiers': ((json['tiers'] as Array<any>).map(PayoutTierFromJSON)),
        'isDefault': json['isDefault'],
        'isActive': json['isActive'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function PayoutTableResponseToJSON(json: any): PayoutTableResponse {
    return PayoutTableResponseToJSONTyped(json, false);
}

export function PayoutTableResponseToJSONTyped(value?: PayoutTableResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'minTeams': value['minTeams'],
        'maxTeams': value['maxTeams'],
        'distribution': ((value['distribution'] as Array<any>).map(PayoutDistributionToJSON)),
        'tiers': ((value['tiers'] as Array<any>).map(PayoutTierToJSON)),
        'isDefault': value['isDefault'],
        'isActive': value['isActive'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

